export default __webpack_public_path__ + "static/media/kitchen3-afterE.f9a73516.jpg";